import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { GTM } from '../../constants';
const appendGtmClassName = (settings, childComponents) => {
  if (!childComponents || Array.isArray(childComponents)) return settings;
  const {
    props: {
      children: [, compChildren]
    }
  } = childComponents;
  if (!compChildren || !Array.isArray(compChildren)) return settings;
  const gtmClassNames = compChildren.filter(({
    props: {
      component: {
        type
      }
    }
  }) => type === GTM).map(({
    props: {
      component: {
        settings: {
          gtmClassName
        }
      }
    }
  }) => gtmClassName).filter(Boolean).join(' ');
  if (!gtmClassNames.length) return settings;
  const {
    modifier
  } = settings;
  const updatedModifier = `${modifier || ''} ${gtmClassNames}`.trim();
  return _objectSpread(_objectSpread({}, settings), {}, {
    modifier: updatedModifier
  });
};
export default appendGtmClassName;
//# sourceMappingURL=append-gtm-classname.js.map